"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PanelLanguageSchema = void 0;
exports.parsePanelLanguage = parsePanelLanguage;
const zod_1 = require("zod");
exports.PanelLanguageSchema = zod_1.z.object({
  id: zod_1.z.number(),
  code: zod_1.z.string(),
  title: zod_1.z.string(),
  title_native: zod_1.z.string(),
  url: zod_1.z.string().optional(),
  domain_switch_description: zod_1.z.string().optional()
});
function parsePanelLanguage(values) {
  return exports.PanelLanguageSchema.parse(values);
}
